import { PlusIcon } from '@svgs'
import { FC, useState } from 'react'
import Logo from 'src/components/elements/logo/Logo'

import { useTranslation } from 'react-i18next'
import { Button } from 'src/components/ui'
import { CreateRequestModal } from '../modals'
import { NotificationsDropdown, UserDropdown } from './components'
import { Link } from 'react-router-dom'

interface IHeader {}

const Header: FC<IHeader> = () => {
  const { t } = useTranslation()
  const [openCreateRequestModal, setOpenCreateRequestModal] = useState(false)

  return (
    // Phones: fixed, its content clear of the notch and the status bar
    // (--header-h and --safe-* in styles/index.css)
    <header className="md:h-auto h-[var(--header-h)] flex flex-row items-center md:justify-end justify-between gap-5 fixed md:absolute top-0 right-0 md:p-8 py-2 p-4 md:py-9 max-md:pt-[calc(0.5rem+var(--safe-top))] short:pt-[calc(0.375rem+var(--safe-top))] short:pb-1.5 max-md:pl-[max(1rem,var(--safe-left))] max-md:pr-[max(1rem,var(--safe-right))] z-[70] md:bg-transparent bg-surface md:shadow-none md:border-none shadow-[0rem_.25rem_3.375rem_0rem_rgba(0,0,0,0.09)] border-b border-ink border-opacity-10 md:w-auto w-full">
      <div className="flex items-center md:justify-end justify-between gap-3 w-full">
        <Link to="/" className="md:hidden flex items-center h-[2.625rem] shrink-0">
          <Logo
            className="h-full"
            imageClassName="w-[7.5rem] h-full"
            textClassName="text-[0.9375rem]"
          />
        </Link>
        {/* One interface for everyone (38.2): listing is the primary market
            action, saving a request stays one click away as the secondary */}
        <div className="md:flex hidden items-center gap-3">
          <Button link="/create-ad" className="!h-11 !gap-4" iconAfter={<PlusIcon />}>
            {t('create_ad')}
          </Button>
          <Button
            onClick={() => setOpenCreateRequestModal(true)}
            variant="outlined"
            className="!h-11 !gap-4"
          >
            {t('create_a_request')}
          </Button>
        </div>

        <div className="flex items-center gap-3">
          <NotificationsDropdown />
          <UserDropdown />
        </div>
      </div>
      <CreateRequestModal
        open={openCreateRequestModal}
        handleClose={() => setOpenCreateRequestModal(false)}
      />
    </header>
  )
}

export default Header
